import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { formatDate } from '../../lib/format';
import AdminLayout from '../../components/AdminLayout';
import { Card } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { useAuth } from '../../context/AuthContext';

const ROLES = ['SUPER_ADMIN','ADMIN','ACADEMY_ADMIN','FINANCE_ADMIN','SUPPORT_ADMIN','MEMBER'];

export default function AdminUsers() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const load = () => api.get('/admin/users').then(r => setUsers(r.data.users)).catch(()=>{});
  useEffect(() => { load(); }, []);
  const change = async (id, role) => { try { await api.post(`/admin/users/${id}/role`, { role }); toast.success('Role diperbarui'); load(); } catch (e) { toast.error(e.response?.data?.detail||'Gagal'); } };

  return (
    <AdminLayout title="Users & Roles">
      <Card className="p-4 mb-4 text-sm text-muted-foreground">RBAC: SUPER_ADMIN (full) · FINANCE_ADMIN (payments/komisi/withdrawal/ledger) · ACADEMY_ADMIN (course/lesson/quiz) · SUPPORT_ADMIN (members/support). Hanya SUPER_ADMIN dapat mengubah role.</Card>
      <Card className="p-0 overflow-hidden"><div className="overflow-x-auto">
        <Table><TableHeader><TableRow><TableHead>Nama</TableHead><TableHead>Email</TableHead><TableHead>Bergabung</TableHead><TableHead>Role</TableHead></TableRow></TableHeader>
          <TableBody>{users.map(u => (
            <TableRow key={u.user_id}><TableCell className="font-medium">{u.name}</TableCell><TableCell className="text-xs">{u.email}</TableCell><TableCell className="text-xs">{formatDate(u.created_at)}</TableCell>
              <TableCell>{user?.role==='SUPER_ADMIN' ? (
                <Select value={u.role} onValueChange={(v)=>change(u.user_id,v)}><SelectTrigger className="w-40 h-8" data-testid={`role-${u.user_id}`}><SelectValue /></SelectTrigger><SelectContent>{ROLES.map(r=><SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent></Select>
              ) : <span className="text-sm">{u.role}</span>}</TableCell>
            </TableRow>
          ))}</TableBody>
        </Table>
      </div></Card>
    </AdminLayout>
  );
}
